import React from 'react'
import Input from 'antd/lib/input'
import styled, { css } from 'styled-components'
import { isKeyPressEnter } from '../util/isKeyPressEnter'
import { TextInputProps, TextInputElements } from './TextInput'
import { InputContainer } from './InputContainer'
import { insertTestingSelector } from '../util/testing'
import { BORDER_RADIUS, SPACING } from '../styles/mixins/constants'
import { color } from '../styles'
import { text } from '../styles/mixins/text'

export const TextArea = (props: TextInputProps): JSX.Element => {
    const {
        value,
        onChange,
        className,
        label,
        disabled,
        errorMessage,
        placeholder,
        name,
        hasDanger: displayDanger,
        onEnterPress,
        onBlur,
        testingKeys,
    } = props

    const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
        if (!isKeyPressEnter(e)) return
        if (!onEnterPress) return
        onEnterPress()
    }

    const hasErrorState = Boolean(errorMessage || displayDanger)
    const testingSelectors = testingKeys ? insertTestingSelector(...testingKeys) : {}
    return (
        <Container
            className={className}
            disabled={Boolean(disabled)}
            errorMessage={errorMessage}
            hasDanger={hasErrorState}
            label={label}
        >
            <Input.TextArea
                {...testingSelectors}
                name={name}
                disabled={disabled}
                value={value || undefined}
                placeholder={placeholder}
                onKeyUp={handleKeyUp}
                onBlur={onBlur}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): null => {
                    if (!onChange) return null

                    onChange(e?.target?.value)
                    return null
                }}
            />
        </Container>
    )
}

const Container = styled(InputContainer)`
    & .ant-input {
        padding: ${SPACING[1]} ${SPACING[3]};
        border-radius: ${BORDER_RADIUS};
        border: 1px solid ${color.border.muted};
        ${text('paragraph', 'primary', 'text')}
        background-color: ${color.background.content};
        &::placeholder {
            ${text('paragraph', 'muted', 'text')}
        }
        &:hover {
            border: 1px solid ${color.brand.primary};
        }
    }
    .ant-input:focus {
        ${TextInputElements.FOCUS_STYLE}
    }

    textarea.ant-input-disabled {
        ${TextInputElements.DISABLED_STYLE}
    }

    ${(p) => {
        if (p.disabled) return ''
        if (!p.hasDanger && !p.errorMessage) return ''
        return css`
            && .ant-input {
                ${TextInputElements.ERROR_STYLE}
            }
        `
    }}
`
